import Button from '../../react/components/Button';
import WithHrListSupportModal from '../../react/features/Navigation/SupportLink/WithHrListSupportModal';
import { ErrorCard, RouteErrorPlain } from './plain';

type Props = {
    errorCode?: string | number | null;
    error?: unknown;
};

export default function RouteError(props: Props) {
    return <RouteErrorPlain {...props} renderInfoButton={code => code === 403 && <AdminsModal />} />;
}

function AdminsModal() {
    return (
        <WithHrListSupportModal>
            {({ openModal }) => <Button onClick={openModal}>See Admins</Button>}
        </WithHrListSupportModal>
    );
}

export { ErrorCard };
